// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"915a4bda","488":"9193d111","750":"cbe837b9","859":"14950628","914":"aecca61e"}[chunkId] + ".chunk.js";
};